import { styled, Box, ButtonBase, Button, Typography, CircularProgress } from '@mui/material';

export function ActionButton(props) {
    return <StyledActionButton {...props} />;
}

const StyledActionButton = styled(Button)(({ theme }) => ({
    backgroundColor: 'rgba(25, 118, 210, 0.1)',
    color: theme.palette.secondary.main,
    '&:hover': {
        borderColor: theme.palette.action.hover,
        backgroundColor: theme.palette.action.hover,
    },
}));

StyledActionButton.defaultProps = {
    variant: 'contained',
    disableElevation: true,
};

export function DangerButton(props) {
    return <StyledDangerButton {...props} />;
}

const StyledDangerButton = styled(Button)(({ theme }) => ({
    backgroundColor: 'rgba(210, 25, 25, 0.1)',
    color: theme.palette.error.main,
    '&:hover': {
        borderColor: theme.palette.action.hover,
        backgroundColor: theme.palette.action.hover,
    },
}));

StyledDangerButton.defaultProps = {
    variant: 'contained',
    disableElevation: true,
};


// ***** Cancel Button ***** //

export const CancelButton = styled(Button)(({ theme }) => ({
    color: theme.palette.warning.main,
    borderColor: theme.palette.warning.main,
    marginLeft: theme.spacing(2),
    '&:hover': {
        borderColor: theme.palette.warning.main,
        backgroundColor: theme.palette.action.hover,
    },
}));

CancelButton.defaultProps = { variant: 'outlined' };


// ***** Submit Button ***** //

export const SubmitButton = (props) => {
    const loading = Boolean(props.loading);

    // Remove props not intended for the button component
    const buttonProps = { ...props, loading: undefined };

    return (
        <StyledSubmitButton {...buttonProps}>
            {loading === true ? <StyledSubmitButtonSpinner /> : props.children}
        </StyledSubmitButton>
    );
};

const StyledSubmitButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
    marginLeft: theme.spacing(2),
    '&:hover': {
        borderColor: theme.palette.common.white,
        backgroundColor: theme.palette.action.hover,
    },
}));

StyledSubmitButton.defaultProps = { variant: 'contained', size: 'medium' };

const StyledSubmitButtonSpinner = styled(CircularProgress)(({ theme }) => ({
    color: theme.palette.common.white,
}));

StyledSubmitButtonSpinner.defaultProps = { size: 24 };


// ***** Delete Button ***** //

export const DeleteButton = styled(Button)(({ theme }) => ({
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main,
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
        borderColor: theme.palette.error.main,
    },
}));

DeleteButton.defaultProps = { variant: 'outlined' };

export function EventShortcut(props) {
    const { id, name, image, status, onClick } = props;

    return (
        <EventButton focusRipple onClick={() => onClick(id)}>
            <Box height="46px">
                <Image src={image} />
            </Box>
            <Box minWidth={0} mx={2}>
                <EventName>{name}</EventName>
                {status === 'draft' && <OrangeText>Draft</OrangeText>}
                {status === 'upcoming' && <BlueText>Upcoming</BlueText>}
                {status === 'live' && <GreenText>Live</GreenText>}
            </Box>
        </EventButton>
    );
}

const EventButton = styled(ButtonBase)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
    height: '48px',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
}));

const EventName = styled(Typography)(({ theme }) => ({
    fontSize: '14px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
}));

const Image = styled('img')(({ theme }) => ({
    objectFit: 'contain',
    height: '100%',
    borderTopLeftRadius: '4px',
    borderBottomLeftRadius: '4px',
    textAlign: 'left',
}));

const BlueText = styled(Typography)(({ theme }) => ({
    color: theme.palette.info.main,
    fontWeight: 'bold',
    textAlign: 'left',
    fontSize: '12px',
}));

const GreenText = styled(Typography)(({ theme }) => ({
    color: theme.palette.success.main,
    fontWeight: 'bold',
    textAlign: 'left',
    fontSize: '12px',
}));

const OrangeText = styled(Typography)(({ theme }) => ({
    color: theme.palette.warning.main,
    fontWeight: 'bold',
    textAlign: 'left',
    fontSize: '12px',
}));
